import { distanceKm, extractEventVenueLocation, GeoPoint, zoomToFit } from './event-map-geo';

export const NEAR_ME_RADIUS_KM = 150;

export function eventDistanceKm(event: unknown, origin: GeoPoint): number | null {
  const point = extractEventVenueLocation(event).point;
  if (!point) {
    return null;
  }
  return distanceKm(origin, point);
}

export function sortEventsByDistance<T>(events: T[], origin: GeoPoint | null): T[] {
  if (!origin) {
    return events;
  }
  return [...events].sort((left, right) => {
    const leftKm = eventDistanceKm(left, origin);
    const rightKm = eventDistanceKm(right, origin);
    if (leftKm == null && rightKm == null) {
      return 0;
    }
    if (leftKm == null) {
      return 1;
    }
    if (rightKm == null) {
      return -1;
    }
    return leftKm - rightKm;
  });
}

export function nearMeCamera(
  origin: GeoPoint,
  eventPoints: readonly GeoPoint[],
  width: number,
  height: number,
): { readonly center: GeoPoint; readonly zoom: number } {
  const viewW = width > 0 ? width : 800;
  const viewH = height > 0 ? height : 640;
  const nearby = eventPoints.filter(
    (point) => distanceKm(origin, point) <= NEAR_ME_RADIUS_KM,
  );
  if (nearby.length > 0) {
    return zoomToFit([origin, ...nearby], viewW, viewH);
  }
  const closest = closestEventPoint(origin, eventPoints);
  if (!closest) {
    return { center: origin, zoom: 11 };
  }
  return { center: closest, zoom: 12 };
}

function closestEventPoint(
  origin: GeoPoint,
  eventPoints: readonly GeoPoint[],
): GeoPoint | null {
  if (eventPoints.length === 0) {
    return null;
  }
  let best = eventPoints[0];
  let bestKm = distanceKm(origin, best);
  for (const point of eventPoints) {
    const km = distanceKm(origin, point);
    if (km < bestKm) {
      best = point;
      bestKm = km;
    }
  }
  return best;
}
